import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import AuthPage from './pages/Auth';
import routes from './components/RoutesConfig';
import { logout } from './api/api';
import MatchList from './pages/MatchList';
import InfoGala from './pages/InfoGala';
import Affiliazione from './pages/Affiliazione';
import MatchArea from './pages/MatchArea';
import AllMatches from './pages/AllMatches';
import MatchDetails from './pages/MatchDetails';
import ResetPasswordPage from './pages/ResetPassword';
import Rankings from './pages/Rankings';

function App() {
  const [user, setUser] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const [loadingUser, setLoadingUser] = useState(true);

  // Controllo token all'avvio
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser({ email: payload.email, role: payload.role || "coach" });
      } catch {
        logout();
        setUser(null);
      }
    }
    setLoadingUser(false);
  }, []);

  // Logout automatico dopo 1 ora di inattività
  useEffect(() => {
    if (!user) return;

    const SESSION_TIMEOUT = 60 * 60 * 1000;
    let timer = setTimeout(handleLogout, SESSION_TIMEOUT);

    function handleLogout() {
      logout();
      setUser(null);
    }

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(handleLogout, SESSION_TIMEOUT);
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("touchstart", resetTimer);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("touchstart", resetTimer);
    };
  }, [user]);

  if (loadingUser) {
    return <div>Caricamento...</div>;
  }

  if (!user) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<AuthPage setUser={setUser} />} />
          <Route path="/match-list" element={<MatchList/>} />
          <Route path="/allMatches" element={<AllMatches/>} />
          <Route path="/info-gala" element={<InfoGala/>} />
          <Route path="/match-area" element={<MatchArea/>} />
          <Route path="/affiliazione" element={<Affiliazione/>} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/rankings" element={<Rankings />} />
        </Routes>
      </Router>
    );
  }

  // Decide la route iniziale in base al ruolo
  const defaultPath = user.role === "admin" ? "/dashboard" : "/participants";

  return (
    <Router>
      <Sidebar
        show={showSidebar}
        toggle={() => setShowSidebar(!showSidebar)}
        setUser={setUser}
        role={user.role}
      />

      {!showSidebar && (
        <button
          onClick={() => setShowSidebar(true)}
          style={{
            position: 'fixed', top: 15, left: 15, zIndex: 1700,
            backgroundColor: '#1e1e2f', color: '#fff', border: 'none',
            padding: '10px 15px', borderRadius: '8px', fontSize: '20px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
          }}
        >☰</button>
      )}

      <div style={{ padding: '20px', paddingTop: '60px', marginLeft: 0, height: '100%', overflowY: 'auto' }}>
        <Routes>
          {routes.map(r => {
            if (!r.roles.includes(user.role)) return null;
            return (
              <Route
                key={r.path}
                path={r.path}
                element={
                  <r.component
                    isAdmin={user.role === "admin"}  // qui passi la prop
                  />
                }
              />
            );
          })}
          <Route path="*" element={<Navigate to={defaultPath} replace />} />
          <Route path="/match/:areaId/:categoria" element={<MatchDetails />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
